<div id="ht">
    <div id="main-cnt">
        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
                <ion-buttons slot="start" class="nav-content">
                    <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
                        <span class="breadcrumb"
                        >AMM. - COMMERC. - I MIEI BONUS - {{ project }} - {{ period
                            }}</span
                        >
                    </div>
                </ion-buttons>
                <div slot="end" class="notification-div">

                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
                        <img [src]="sessionService?.user?.profileImg|s3Link">

                    </ion-avatar>
                </div>
                <app-add-bookmark slot="end"
                        pageTitle="I miei Bonus"
                        url="/my-bonuses"
                ></app-add-bookmark>
            </ion-toolbar>
            <br/>

            <!-- edit da qui... -->
            <div class="glass-blurred-background panel-buttons-container">
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel === 'overview'"
                        (click)="currentPanel = 'overview'"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/overview.svg"
                        />
                    </div>
                    <h4>Overview</h4>
                </div>
                <div
                        class="panel-button theme-text-color"
                        [class.active]="currentPanel === 'pagamenti'"
                        (click)="currentPanel = 'pagamenti'"
                >
                    <div class="panel-button-image-container">
                        <img
                                class="panel-button-image svg-white"
                                src="./assets/imgs/pagamenti.svg"
                        />
                    </div>
                    <h4>Pagamenti</h4>
                </div>
            </div>


            <h3 class="panel-title" *ngIf="currentPanel === 'pagamenti'">Pagamenti</h3>
            <!-- ...a qui -->
        </ion-header>

        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <!-- <div class="content with-floating-footer"> -->
                    <div class="content">
                        <!-- edit da qui... -->

                        <app-user-bonuses [owner]="user" *ngIf="user"></app-user-bonuses>
                        <!-- <div class="flex-panel" *ngIf="currentPanel == 'overview'">
                                         <div class="glass-blurred-background drop-shadow padding text-bold">

                                             <div class="flex-row">
                                                 <div class="flex-left">
                                                     <div>Carriera</div>
                                                 </div>
                                                 <div class="flex-right">
                                                     <div>Advisor/Executive</div>
                                                 </div>
                                             </div>

                                             <div class="flex-row"  *ngFor="let step of careerController?.careerProgress$|async">
                                                 <div class="flex-left">
                                                     <div>{{step.career.title}} </div>
                                                 </div>
                                                 <div class="flex-right">
                                                     <div class="progress-bar-background">
                                                         <div class="progress-bar-color" style="width: {{(step.percent ? step.percent : 0 * 100)  }} %;">
                                                             <span class="progress-bar-percent">{{(step.percent ? step.percent : 0 * 100)  }} % </span>
                                                         </div>
                                                     </div>
                                                 </div>
                                             </div>


                                               <div class="flex-row">
                                                  <div class="flex-left">
                                                      <div>to Leader Advisor</div>
                                                  </div>
                                                  <div class="flex-right">
                                                      <div class="progress-bar-background">
                                                          <div class="progress-bar-color" style="width: 50%;">
                                                              <span class="progress-bar-percent">50%</span>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>

                                         </div>

                                         <br>

                                         <div class="glass-blurred-background drop-shadow padding text-bold">
                                             <div class="flex-row">
                                                 <div class="flex-left">
                                                     <div>Fatturato Tot</div>
                                                 </div>
                                                 <div class="flex-right">
                                                     <div>{{careerController?.totalRevnue$ |async}}</div>
                                                 </div>
                                             </div>
                                         </div>

                                         <br>

                                         <div class="flex-tabs text-bold">
                                             <div class="flex-tab glass-blurred-background drop-shadow padding">
                                                 mensile
                                             </div>
                                             <div class="flex-tab glass-blurred-background drop-shadow padding">
                                                 trimestrale
                                             </div>
                                             <div class="flex-tab glass-blurred-background drop-shadow padding">
                                                 annuale
                                             </div>
                                         </div>

                                         <br>
                                         <ion-accordion-group>
                                             <ion-accordion class="bg-transparent" value="marketingFee" toggle-icon="arrow-down-circle" toggle-icon-slot="start">

                                                     <ion-item  class="flex-row header color-white"  slot="header">
                                                         <div class="flex-left">
                                                             <div>
                                                                 Marketing fee
                                                             </div>
                                                         </div>
                                                         <div class="flex-right float-right" >
                                                             <div>€ {{(careerController?.marketingFee1$ |async)?.total}}</div>
                                                         </div>
                                                     </ion-item>

                                                     <div class="panel show" slot="content">
                                                         <div class="flex-row">
                                                             <div class="flex-left">
                                                                <div *ngFor="let b of (careerController?.marketingFee1$ |async)?.bonuses">
                                                                    {{b|json}}
                                                                </div>
                                                             </div>
                                                         </div>
                                                     </div>




                                             </ion-accordion>

                                             <ion-accordion class="bg-transparent" value="managerFee" toggle-icon="arrow-down-circle" toggle-icon-slot="start">


                                             <ion-item  class="flex-row header color-white"  slot="header">
                                                 <div class="flex-left">
                                                     <div>
                                                         Manager fee
                                                     </div>
                                                 </div>
                                                 <div class="flex-right">
                                                     <div>€ {{(careerController?.mmanagerFee2$ |async)?.total}}</div>

                                                 </div>
                                             </ion-item>>

                                             <div class="panel " slot="content">

                                                 <div class="flex-row">
                                                     <div class="flex-left">
                                                         <div class="flex-left">
                                                             <div *ngFor="let b of (careerController?.marketingFee1$ |async)?.bonuses">
                                                                 {{b|json}}
                                                             </div>
                                                         </div>
                                                     </div>
                                                 </div>
                                             </div>


                                             </ion-accordion>
                                         </ion-accordion-group>
                                         <div class="flex-collapsible">
                                             <div class="flex-row header">
                                                 <div class="flex-left">
                                                     <div>
                                                         <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg">
                                                         Team Bonus
                                                     </div>
                                                 </div>
                                                 <div class="flex-right">
                                                     <div class="progress-bar-background">
                                                         <div class="progress-bar-color" style="width: 80%;">
                                                             <span class="progress-bar-percent">80%</span>
                                                         </div>
                                                     </div>
                                                 </div>
                                             </div>

                                             <div class="panel">
                                                 <div class="flex-row">
                                                     <div class="flex-left">
                                                         <div class="glass-blurred-background drop-shadow padding">

                                                             <div class="flex-row">
                                                                 <div class="flex-left text-bold">
                                                                     <div>Volume</div>
                                                                 </div>
                                                                 <div class="flex-right text-bold">
                                                                     <div>Bonus</div>
                                                                 </div>
                                                             </div>
                                                             <div class="flex-row">
                                                                 <div class="flex-left">
                                                                     <div>N. membri*€ 10.000</div>
                                                                 </div>
                                                                 <div class="flex-right">
                                                                     <div>0,50%</div>
                                                                 </div>
                                                             </div>
                                                             <div class="flex-row">
                                                                 <div class="flex-left">
                                                                     <div>N. membri*€ 10.000</div>
                                                                 </div>
                                                                 <div class="flex-right">
                                                                     <div>1,00%</div>
                                                                 </div>
                                                             </div>
                                                             <div class="flex-row">
                                                                 <div class="flex-left">
                                                                     <div>N. membri*€ 10.000</div>
                                                                 </div>
                                                                 <div class="flex-right">
                                                                     <div>1,50%</div>
                                                                 </div>
                                                             </div>

                                                         </div>
                                                     </div>
                                                 </div>
                                             </div>

                                             <div class="flex-row subheader">
                                                 <div class="flex-left"></div>
                                             </div>
                                         </div>
                                     </div> -->

                        <div class="flex-panel" *ngIf="currentPanel === 'pagamenti'">
                            <div class="flex-row">
                                <div class="flex-1"><b>ID.N.</b></div>
                                <div class="flex-1"><b>Commis.</b></div>
                                <div class="flex-1"><b>Data</b></div>
                            </div>

                            <!-- <div *ngSwitchCase="'mensile'"> -->
                            <div *ngFor="let payment of paymentsByMese">
                                <div class="flex-row">
                                    <div class="flex-1">
                    <span
                            class="fakeLink"
                            (click)="openContract(payment.contractID)"
                    >{{ payment.contractID }}</span
                    >
                                    </div>
                                    <div
                                            class="flex-1"
                                            [ngClass]="{'green-text' : payment.status === 'Pagato', 'red-text' : payment.status === 'Non pagato'}"
                                    >
                                        {{ payment.total | currency:'EUR' }}
                                    </div>
                                    <div class="flex-1">
                                        {{ payment.payDate | date : 'd/MM/YY' }}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>

<!-- <ion-header>
    <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
            <div size="2" class="nav-back">
        <span class="custom-icon-back-arrow-icon" (click)="back()">
          <span class="path1"></span>
          <span class="path2"></span>
        </span>
                <span class="breadcrumb">AMM. - COMMERC. - I MIEI BONUS - {{ project }} - {{ period }}</span>
            </div>
        </ion-buttons>
        <div class="notification-div">
            <div class="menu-user-icon" (click)="openPage('/my-profile')">

            </div>
        </div>
    </ion-toolbar>

    <img src="./assets/imgs/Logo-new.png" class="whiteLogo slide-in"/>

</ion-header> -->

<!-- <ion-content>
    <div class="project-empty-div">
        <ion-item lines="none" class="project-view">
            <span slot="start" class="head-title"></span>
        </ion-item>
    </div>

    <div class="project-content-div">
        <ion-segment class="project-segment" [(ngModel)]="project">
            <ion-segment-button value="overview" checked="true" (click)="setOverViewStyle('temporal')">
                <div class="seg-btn">
                    <span class="custom-icon-projects-overview-icon selected-icon"></span>
                </div>
                <span style="color: black !important;margin-top: 6px;">OVERVIEW</span>
            </ion-segment-button>

            <ion-segment-button value="overview" checked="true" (click)="setOverViewStyle('category')">
                <div class="seg-btn">
                    <span class="custom-icon-projects-overview-icon selected-icon"></span>
                </div>
                <span style="color: black !important;margin-top: 6px;">OVERVIEW</span>
            </ion-segment-button>
            <ion-segment-button value="pagamenti">
                <div class="seg-btn">
                    <span class="custom-icon-projects-calendar-icon selected-icon"></span>
                </div>
                <span style="color: black !important;margin-top: 6px;">PAGAMENTI</span>
            </ion-segment-button>
        </ion-segment>

        <div class="padding bold" [ngSwitch]="project">
            <div *ngSwitchCase="'overview'" class="seg-content">

                <app-user-bonuses [owner]="sessionService.user"  [style]="overViewStyle"></app-user-bonuses>

            </div>

            <div *ngSwitchCase="'pagamenti'">
                <div [ngSwitch]="period">
                    <ion-row>
                        <ion-col size="6">ID.N.</ion-col>
                        <ion-col size="3">Commis.</ion-col>
                        <ion-col size="3">Data</ion-col>
                    </ion-row>

                    <div *ngSwitchCase="'mensile'">
                        <ion-row *ngFor="let payment of paymentsByMese">
                            <ion-col size="6"><span class="fakeLink"
                                                    (click)="openContract(payment.contractID)">{{ payment.contractID }}</span>
                            </ion-col>
                            <ion-col
                                    [ngClass]="{'green-text' : payment.status == 'Pagato', 'red-text' : payment.status == 'Non pagato'}"
                                    size="3">{{ payment.total | currency:'EUR' }}</ion-col>
                            <ion-col size="3">{{ payment.payDate | date : 'd/MM/YY' }}</ion-col>
                        </ion-row>
                    </div>
                    <div *ngSwitchCase="'trimestrale'">
                        <ion-row *ngFor="let payment of paymentsByTrimestre">
                            <ion-col size="6"><span class="fakeLink"
                                                    (click)="openContract(payment.contractID)">{{ payment.contractID }}</span>
                            </ion-col>
                            <ion-col
                                    [ngClass]="{'green-text' : payment.status == 'Pagato', 'red-text' : payment.status == 'Non pagato'}"
                                    size="3">{{ payment.total | currency:'EUR' }}</ion-col>
                            <ion-col size="3">{{ payment.payDate | date : 'd/MM/YY' }}</ion-col>
                        </ion-row>
                    </div>
                    <div *ngSwitchCase="'annuale'">
                        <ion-row *ngFor="let payment of paymentsByAnno">
                            <ion-col size="6"><span class="fakeLink"
                                                    (click)="openContract(payment.contractID)">{{ payment.contractID }}</span>
                            </ion-col>
                            <ion-col
                                    [ngClass]="{'green-text' : payment.status == 'Pagato', 'red-text' : payment.status == 'Non pagato'}"
                                    size="3">{{ payment.total | currency:'EUR' }}</ion-col>
                            <ion-col size="3">{{ payment.payDate | date : 'd/MM/YY' }}</ion-col>
                        </ion-row>
                    </div>
                </div>
            </div>

        </div>

    </div>

</ion-content> -->
